module.exports = __webpack_public_path__ + "img/003.c94e0abd.png";